import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { isPast } from 'date-fns';

import { withFragments } from '@sorare/core/src/lib/gql';

import type { isTaskLive_gameWeeklyTask } from './__generated__/utils.graphql';

export const isTaskLive = withFragments(
  (task: isTaskLive_gameWeeklyTask) => isPast(task.so5Fixture.cutOffDate),
  {
    gameWeeklyTask: gql`
      fragment isTaskLive_gameWeeklyTask on GameWeeklyTask {
        id
        so5Fixture {
          slug
          cutOffDate
        }
      }
    ` as TypedDocumentNode<isTaskLive_gameWeeklyTask>,
  }
);
